/* Bonfi product-page motion (companion to bonfi-product.css):
   - gallery 3D tilt + cursor gloss on pointer devices
   - add-to-cart success morph + header cart bump (+ fly-to-cart when cart is a page)
   Listens to the theme's own events (theme:cart:added / theme:cart:error). */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ------------------------------------------------------------
     1. Gallery tilt + gloss
     ------------------------------------------------------------ */
  var MAX_TILT = 6; // degrees
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initTilt(media) {
    if (!finePointer || media.dataset.bonfiTilt) return;
    media.dataset.bonfiTilt = 'true';
    media.classList.add('bonfi-tilt');

    var gloss = document.createElement('span');
    gloss.className = 'bonfi-gloss';
    gloss.setAttribute('aria-hidden', 'true');
    media.appendChild(gloss);

    var raf = null;
    var last = null;

    function apply() {
      raf = null;
      if (!last) return;
      var r = media.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var px = (last.x - r.left) / r.width;   // 0..1
      var py = (last.y - r.top) / r.height;   // 0..1
      var dx = px - 0.5;
      var dy = py - 0.5;
      media.style.setProperty('--bonfi-ry', (dx * MAX_TILT * 2).toFixed(2) + 'deg');
      media.style.setProperty('--bonfi-rx', (-dy * MAX_TILT * 2).toFixed(2) + 'deg');
      media.style.setProperty('--bonfi-s', '1.015');
      media.style.setProperty('--bonfi-gx', (px * 100).toFixed(1) + '%');
      media.style.setProperty('--bonfi-gy', (py * 100).toFixed(1) + '%');
    }

    media.addEventListener('pointerenter', function () {
      media.classList.remove('is-settling');
    });

    media.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      last = { x: e.clientX, y: e.clientY };
      if (!raf) raf = window.requestAnimationFrame(apply);
    });

    media.addEventListener('pointerleave', function () {
      last = null;
      media.classList.add('is-settling');
      media.style.setProperty('--bonfi-rx', '0deg');
      media.style.setProperty('--bonfi-ry', '0deg');
      media.style.setProperty('--bonfi-s', '1');
    });
  }

  function initAllTilts(root) {
    (root || document).querySelectorAll('.product-gallery__media--image').forEach(initTilt);
  }

  /* ------------------------------------------------------------
     2. Add-to-cart success morph + cart bump
     ------------------------------------------------------------ */
  var pending = [];
  var CHECK_SVG =
    '<svg viewBox="0 0 192 192" aria-hidden="true" focusable="false">' +
    '<path d="M40 100 L82 142 L154 58"/></svg>';

  function ensureCheck(btn) {
    if (btn.querySelector('.bonfi-atc-check')) return;
    var holder = document.createElement('span');
    holder.className = 'bonfi-atc-check';
    holder.setAttribute('aria-hidden', 'true');
    holder.innerHTML = CHECK_SVG;
    btn.appendChild(holder);
  }

  // Success state is timed in *rendered* frames (rAF timestamps), not wall
  // clock: this theme's cart drawer can freeze rendering for 1-2s right after
  // an add, and the checkmark must still get its full on-screen time.
  function morph(btn) {
    ensureCheck(btn);
    var text = btn.querySelector('[data-add-to-cart-text]');
    btn.classList.remove('bonfi-atc-success');
    if (text) text.classList.remove('bonfi-hidden');
    // force reflow so a rapid second add replays the animation
    void btn.offsetWidth;
    btn.classList.add('bonfi-atc-success');
    var start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var elapsed = ts - start;
      if (text && elapsed > 260) text.classList.add('bonfi-hidden');
      if (elapsed < 1700) {
        window.requestAnimationFrame(frame);
        return;
      }
      btn.classList.remove('bonfi-atc-success');
      if (text) text.classList.remove('bonfi-hidden');
    }
    window.requestAnimationFrame(frame);
  }

  function bumpCart() {
    document.querySelectorAll('.cart__toggle').forEach(function (el) {
      el.classList.remove('bonfi-cart-bump');
      void el.offsetWidth;
      el.classList.add('bonfi-cart-bump');
      var icon = el.querySelector('.icon');
      var done = function () {
        el.classList.remove('bonfi-cart-bump');
        if (icon) icon.removeEventListener('animationend', done);
      };
      if (icon) icon.addEventListener('animationend', done);
      else window.setTimeout(done, 700);
    });
  }

  function cartIsDrawer() {
    return !!document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
  }

  function visibleCartIcon() {
    var icons = document.querySelectorAll('.cart__toggle');
    for (var i = 0; i < icons.length; i++) {
      var r = icons[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return icons[i];
    }
    return null;
  }

  function flyToCart(btn) {
    if (cartIsDrawer() || typeof Element.prototype.animate !== 'function') return;
    var target = visibleCartIcon();
    var section = btn.closest('.product-single, .featured-product, [data-section-type]') || document;
    var img = section.querySelector('.product-gallery__media-slide:not(.media--hidden) img, .product-gallery__media--image img');
    if (!target || !img) return;

    var from = img.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var size = Math.min(96, from.width);
    var ghost = img.cloneNode(false);
    ghost.removeAttribute('srcset');
    ghost.removeAttribute('sizes');
    ghost.className = 'bonfi-fly';
    ghost.style.left = (from.left + from.width / 2 - size / 2) + 'px';
    ghost.style.top = (from.top + from.height / 2 - size / 2) + 'px';
    ghost.style.width = size + 'px';
    ghost.style.height = size + 'px';
    document.body.appendChild(ghost);

    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
    var anim = ghost.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1, offset: 0 },
        { transform: 'translate(' + (dx * 0.5) + 'px, ' + (dy * 0.5 - 120) + 'px) scale(0.7)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.15)', opacity: 0.2, offset: 1 }
      ],
      { duration: 720, easing: 'cubic-bezier(0.22, 0.9, 0.3, 1)', fill: 'forwards' }
    );
    anim.onfinish = function () { ghost.remove(); };
  }

  function variantIdFor(btn) {
    var form = btn.form || btn.closest('form');
    var input = form && form.querySelector('[name="id"]');
    return input ? String(input.value) : '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product__submit__add, [data-add-to-cart]');
    if (!btn) return;
    btn.dataset.bonfiVariant = variantIdFor(btn);
    if (pending.indexOf(btn) === -1) pending.push(btn);
    window.setTimeout(function () {
      var i = pending.indexOf(btn);
      if (i !== -1) pending.splice(i, 1);
    }, 8000);
  }, true);

  /* Highlight the just-added line item inside the cart drawer. The drawer is
     re-rendered from a fetch after the add, so poll (frame-based) until the
     matching item exists. */
  function highlightDrawerItem(variantId) {
    var drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;
    var start = null;
    function find() {
      var item = null;
      if (variantId) {
        item = drawer.querySelector('[data-cart-item][data-item^="' + variantId + ':"], [data-cart-item][data-item="' + variantId + '"]');
      }
      return item || drawer.querySelector('[data-cart-item]');
    }
    function tick(ts) {
      if (start === null) start = ts;
      var item = find();
      if (!item) {
        if (ts - start < 4000) window.requestAnimationFrame(tick);
        return;
      }
      item.classList.remove('bonfi-item-added');
      void item.offsetWidth;
      item.classList.add('bonfi-item-added');
      var qty = drawer.querySelector('.cart-drawer__item-qty');
      if (qty) {
        qty.classList.remove('bonfi-qty-pop');
        void qty.offsetWidth;
        qty.classList.add('bonfi-qty-pop');
      }
      var shown = null;
      function hold(ts2) {
        if (shown === null) shown = ts2;
        if (ts2 - shown < 1800) {
          window.requestAnimationFrame(hold);
          return;
        }
        item.classList.remove('bonfi-item-added');
        if (qty) qty.classList.remove('bonfi-qty-pop');
      }
      window.requestAnimationFrame(hold);
    }
    window.requestAnimationFrame(tick);
  }

  // The theme's cart drawer blocks rendering for up to ~1s right after the add
  // request resolves. Wait for the next painted frame so the CSS animations
  // start when they can actually be seen instead of finishing off-screen.
  function onNextPaint(fn) {
    var done = false;
    var run = function () {
      if (done) return;
      done = true;
      fn();
    };
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(run);
    });
    // Fallback in case no frame is painted for a long time (drawer overlay etc.)
    window.setTimeout(run, 5000);
  }

  document.addEventListener('theme:cart:added', function () {
    if (!pending.length) return;
    var btns = pending.slice();
    pending.length = 0;
    onNextPaint(function () {
      btns.forEach(function (btn) {
        morph(btn);
        flyToCart(btn);
      });
      bumpCart();
      if (cartIsDrawer()) highlightDrawerItem(btns[0].dataset.bonfiVariant || '');
    });
  });

  document.addEventListener('theme:cart:error', function () {
    pending.length = 0;
  });

  /* ------------------------------------------------------------
     boot
     ------------------------------------------------------------ */
  function init() {
    initAllTilts(document);

    // Pick up galleries rendered later (variant swaps, quick view, section reloads)
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('.product-gallery__media--image')) initTilt(n);
            else if (n.querySelector) initAllTilts(n);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
